import { Helmet } from 'react-helmet-async';
import ContactUsComponent from '../../components/ContactUsComponent'

const features = [
  {
    number: 1,
    title: "Comprehensive Employee Management",
    desc: "JJ Timesheet provides a centralized platform to manage all employee information efficiently. From personal details to job roles and employment history, everything is organized and easily accessible, enabling HR and managers to maintain clear oversight."
  },
  {
    number: 2,
    title: "Accurate Clock-In and Clock-Out Tracking",
    desc: "Track employee working hours precisely, whether on-site or remote. This ensures accurate attendance records, reduces errors, and provides a reliable foundation for payroll and workforce management."
  },
  {
    number: 3,
    title: "Payroll Management",
    desc: "Calculate salaries based on logged hours, overtime, and deductions. Generate clear payroll reports to ensure accuracy and transparency for employees and management alike."
  },
  {
    number: 4,
    title: "Real-Time Attendance Insights",
    desc: "Monitor attendance patterns and trends across your organization. This helps managers make informed decisions about staffing, resource allocation, and workforce planning."
  },
  {
    number: 5,
    title: "Scalable for Any Organization",
    desc: "Whether you manage a small team or a large workforce, JJ Timesheet scales seamlessly. Add employees without losing control or visibility."
  },
  {
    number: 6,
    title: "Enhanced Efficiency and Productivity",
    desc: "By providing accurate tracking, clear reporting, and easy scheduling, JJ Timesheet allows HR and management teams to focus on strategic initiatives rather than manual administrative tasks."
  }
]

const JjTimesheet = () => {
  return (
    <>
      <Helmet>
        <title>JJ Timesheet | Time Tracking & Payroll Software by Data Repo</title>
        <meta
          name="description"
          content="JJ Timesheet by Data Repo helps businesses manage employee attendance, time tracking, and payroll with accuracy and ease."
        />
      </Helmet>

      <section
        style={{
          backgroundImage: `url(../images/bg-casestudies-box.png)`,
          backgroundSize: "100% 80vh"
        }}
        className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border md:h-[80vh] pt-[65px]">
        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase">JJ Timesheet</h1>
        <p className="text-center text-white text-lg md:text-2xl mt-4">
          Streamline Employee Management and Optimize Workforce Efficiency
        </p>
        <div className="row--image-style bg-transparent w-full absolute bottom-0 left-0 right-0">
          <svg className="waves w-full h-44" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 300" preserveAspectRatio="none">
            <path fill="rgb(226 232 240)" d="M 1000 280 l 2 -253 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -235 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"></path>
            <path fill="rgb(100 116 139)" d="M 1000 261 l 2 -222 c -157 -43 -312 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -153.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 16.61 v 22.39 z"></path>
            <path fill="#E5E7EB" d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"></path>
          </svg>
        </div>
      </section>

      <section className="w-full pt-10 px-8 bg-gradient-to-r from-blue-100 via-white to-blue-100 relative overflow-hidden">
        <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-200 rounded-full opacity-30 filter blur-3xl"></div>
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-purple-200 rounded-full opacity-20 filter blur-3xl"></div>

        <div className="flex flex-col md:flex-row items-center justify-center px-16 relative z-10">
          <div className="md:w-1/2 flex justify-center items-center p-5">
            <div className="bg-white rounded-xl shadow-2xl p-4 hover:scale-105 transform transition-transform duration-300">
              <img
                src="../images/jjtimesheet-new.png"
                alt="car rental software dashboard"
                className="rounded-lg"
              />
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center items-center p-5">
            <div className="bg-white rounded-xl shadow-2xl p-4 hover:scale-105 transform transition-transform duration-300">
              <img
                src="../images/jjtimesheet-calendars.png"
                alt="car rental software dashboard"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full items-center justify-center bg-gray-200">
        <div className="max-w-screen-lg mx-auto py-8">
          <div className="px-8 md:px-1 md:pr-2 py-6">
            <div className="mb-4 text-lg font-normal text-center md:text-left text-gray-600">
              <p><strong>Industry:</strong> Human Resources; Workforce Management</p>
              <p><strong>Location:</strong> Global</p>
              <p><strong>Areas of expertise:</strong> Employee management; Time tracking; Payroll; Reporting; Scheduling</p>
              <p><strong>Timeline:</strong> 2020-now</p>
            </div>

            <p className="text-xl font-normal text-center md:text-left text-gray-600">
              JJ Timesheet is a reliable platform that helps organizations manage employees, track attendance, handle payroll, and schedule shifts with accuracy and clarity.
            </p>

            <div className="pt-8">
              <h2 className="text-black text-2xl md:text-3xl font-bold py-5">Key Features</h2>
              <div className="space-y-6 text-xl text-gray-600">
                {features.map((feature) => (
                  <div key={feature.number}>
                    <h3 className="text-2xl font-semibold text-black pb-2">
                      {feature.number}. {feature.title}
                    </h3>
                    <p>{feature.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactUsComponent />
    </>
  )
}

export default JjTimesheet;